import { Box, Typography } from "@mui/material";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import { StyledButton } from "../../../shared/components/buttons/custom-button";
import FormBuilder from "../../../shared/components/form-builder/form-builder";
import { LoaderComponent } from "../../../shared/components/loaders/page-loader";
import { useEffect, useRef, useState } from "react";
import { useApi } from "../../../shared/hooks/useApi";
import { ETCAppConfig } from "../../../shared/app-configs/etc-app-configs";
import { etcTransactionCertificateInitValue, mapJsonToEtcTransactionCertificate } from "../etc-models/Itransaction-model";
import { Utills } from "../../../shared/app-configs/utilit";

const TransactionCertificate: React.FC = () => {
  const [initialValues, setInitalValues] = useState(etcTransactionCertificateInitValue);
      const formRef = useRef<any>(null);
        const { etcId, formtype } = useParams<string>()
    const { loading, error, executeGet } = useApi();
    const navigate = useNavigate();
  const fetchTcBaseDetails = async () => {
      try {
        const response: any = await executeGet(ETCAppConfig.GET_ETC_BASE_DETAILS, { etcId: etcId });
        const data = mapJsonToEtcTransactionCertificate(response.data);
        setInitalValues(data);
      } catch (err) {
        Utills.cle('Failed to fetch TC Base Details:', err);
      }
    };
useEffect(() => {
      fetchTcBaseDetails();
    const fetchData = async () => {
    };
    fetchData();
  }, []);
  const formConfig: any = {
    pageName: "Transaction-Details",
    initialValues,
    readOnly: true,
    validationSchema: null,
    sections: [
      {
        title: "Transaction Certificate Details",
        fields: [
          {
            label: "Transaction Certificate No.",
            name: "etcNo",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Transaction Number",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "eTC Version",
            name: "etcVersionNo",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Version Number",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "eTC Status",
            name: "tcStatus",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select Status",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "eTC Amendment Reason",
            name: "tcAmendmentReason",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            // disabled: true,
            required: false,
            props: {
              placeholder: "Select Amendment Reason",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "eTC Invalidation Reason",
            name: "tcInvalidationReason",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            // disabled: true,
            required: false,
            props: {
              placeholder: "Select Invalidation Reason",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "eTC Delay Reason",
            name: "tcDelayReason",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select Delay Reason",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "Traceabilty Provider Code",
            name: "etcTraceabilityProviderCode",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select Delay Reason",
              variant: "outlined",
              fullWidth: true,
            },
          }
        ]
      },
      {
        title: "Issuance and Application Dates",
        fields: [
          {
            label: "eTC Place of Issue",
            name: "tcPlaceOfIssue",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Place of Issue",
              fullWidth: true,
            },
          },
          {
            label: "eTC Date of Issue",
            name: "tcDateOfIssue",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select Date of Issue",
              fullWidth: true,
            },
          },
          {
            label: "eTC Last Updated",
            name: "tcLastUpdated",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select Last Updated Date",
              fullWidth: true,
            },
          },
          {
            label: "eTC Application Receive",
            name: "tcApplicationReceived",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select Application Received Date",
              fullWidth: true,
            },
          },
          {
            label: "eTC Application Complete",
            name: "tcApplicationComplete",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select Application Complete Date",
              fullWidth: true,
            },
          },
          {
            label: "Associated PO Number",
            name: "etcAssociatedPoNumber",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter PO Number",
              fullWidth: true,
            },
          }
        ]
      },
      {
        title: "Standards and Certifications",
        fields: [
          {
            label: "eTC Standard",
            name: "tcStandard",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            value: initialValues.tcStandard,
            props: {
              placeholder: "",
              fullWidth: true,
            },
          },
          {
            label: "Organic Farm Standards",
            name: "tcOrganicFarmStandard",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            // disabled: true,
            value: initialValues.tcOrganicFarmStandard,
            props: {
              placeholder: "",
              fullWidth: true,
            },
          },
          {
            label: "Certification of the organic material complies with USDA NOP rules",
            name: "tcUsdaNopCompliantFlag",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            props: {
            },
          },
        ]
      }
    ],
    
    handleSubmit: async (values: any) => {
    },
  };
  const handleNext=()=>{
    navigate(`/etc/${formtype}/buyer-seller-details/${etcId}`)
  }

return (
  <Box>
    {/* Render the FormBuilder component and pass formRef and onSubmit handler */}
    {loading ? <LoaderComponent /> :
      <>
        <FormBuilder formConfig={formConfig} onSubmit={formConfig.handleSubmit} formRef={formRef} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <StyledButton variant="contained" onClick={handleNext}>
            Next
          </StyledButton>
          <NavLink to="/tc-dashboard">
            <StyledButton variant="contained">
              Cancel
            </StyledButton>
          </NavLink>
        </Box>
      </>
    }
  </Box>
);
}
export default TransactionCertificate;